import "./DemolitionContractors.module.css";
import Header from "@/reusable_sections/Header";
import DemolitionSupport from "./sections/DemolitionSupport";
import Capabilities from "./sections/Capabilities";
import Leadership from "./sections/Leadership";
import Footer from "@/reusable_sections/Footer";
export default function DemolitionContractorsPage() {
  return <div>
      <Header />
      <DemolitionSupport />
      <Capabilities />
      <Leadership />
      <Footer />
    </div>;
}